import { WalletError, WalletReadyState, WalletNotConnectedError, WalletNotReadyError } from "@solana/wallet-adapter-base";
import { shallowRef, ref, computed, watch, watchEffect } from "vue";
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("i", {
    staticClass: "swv-button-icon"
  }, [_vm.wallet ? _c("img", {
    attrs: {
      "src": _vm.wallet.icon,
      "alt": `${_vm.wallet.name} icon`
    }
  }) : _vm._e()]);
};
var staticRenderFns$4 = [];
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(
        this,
        (options.functional ? this.parent : this).$root.$options.shadowRoot
      );
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __vue2_script$4 = {
  name: "WalletIcon",
  props: {
    wallet: Object
  }
};
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$4,
  render$4,
  staticRenderFns$4,
  false,
  __vue2_injectStyles$4,
  null,
  null,
  null
);
function __vue2_injectStyles$4(context) {
  for (let o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
var WalletIcon = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("button", {
    staticClass: "swv-button swv-button-trigger btn btn-primary text-white",
    attrs: {
      "disabled": _vm.disabled || !_vm.wallet || _vm.connecting || _vm.connected
    },
    on: {
      "click": function(e) {
        return _vm.onClick(e);
      }
    }
  }, [_vm.wallet ? _c("wallet-icon", {
    attrs: {
      "wallet": _vm.wallet
    }
  }) : _vm._e(), _c("p", {
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  })], 1)]);
};
var staticRenderFns$3 = [];
const __vue2_script$3 = {
  name: "WalletConnectButton",
  components: {
    WalletIcon
  },
  props: {
    disabled: {
      type: Boolean
    },
    connecting: false,
    wallet: null,
    connect: null
  },
  data() {
    return {
      connected: false
    };
  },
  computed: {
    content: function() {
      if (this.connecting)
        return "Connecting ...";
      if (this.connected)
        return "Connected";
      if (this.wallet)
        return "Connect";
      return "Connect Wallet";
    }
  },
  methods: {
    onClick: function(event) {
      this.$emit("connect");
      return;
    }
  }
};
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$3,
  render$3,
  staticRenderFns$3,
  false,
  __vue2_injectStyles$3,
  null,
  null,
  null
);
function __vue2_injectStyles$3(context) {
  for (let o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
var WalletConnectButton = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
class WalletNotSelectedError extends WalletError {
  constructor() {
    super(...arguments);
    this.name = "WalletNotSelectedError";
  }
}
class WalletNotInitializedError extends WalletError {
  constructor() {
    super(...arguments);
    this.name = "WalletNotSelectedError";
  }
}
const createWalletStore = ({
  wallets: initialWallets = [],
  autoConnect: initialAutoConnect = false,
  openOnboardingUrls: initialOpenOnboardingUrls = false,
  onError = (error) => console.error(error),
  localStorageKey = "walletName"
}) => {
  const wallets = shallowRef(initialWallets);
  const autoConnect = ref(initialAutoConnect);
  const openOnboardingUrls = ref(initialOpenOnboardingUrls);
  const k = localStorage.getItem(localStorageKey);
  const name = ref(k);
  const wallet = shallowRef(null);
  const publicKey = ref(null);
  const readyState = ref(WalletReadyState.NotDetected);
  const connected = ref(false);
  const connecting = ref(false);
  const disconnecting = ref(false);
  const ready = computed(
    () => readyState.value === WalletReadyState.Installed || readyState.value === WalletReadyState.Loadable
  );
  const setWallet = (newWallet) => {
    var _a, _b, _c;
    console.log("setWallet", newWallet);
    wallet.value = newWallet;
    readyState.value = (_a = newWallet == null ? void 0 : newWallet.readyState) != null ? _a : WalletReadyState.NotDetected;
    publicKey.value = (_b = newWallet == null ? void 0 : newWallet.publicKey) != null ? _b : null;
    connected.value = (_c = newWallet == null ? void 0 : newWallet.connected) != null ? _c : false;
    if (newWallet)
      localStorage.setItem(localStorageKey, newWallet.name);
  };
  const newError = (error) => {
    onError(error);
    return error;
  };
  const walletsByName = computed(() => {
    return wallets.value.reduce(
      (walletsByName2, wallet2) => {
        walletsByName2[wallet2.name] = wallet2;
        return walletsByName2;
      },
      {}
    );
  });
  watch(
    name,
    () => {
      var _a, _b;
      setWallet((_b = (_a = walletsByName.value) == null ? void 0 : _a[name.value]) != null ? _b : null);
    },
    { immediate: true }
  );
  const select = async (walletName) => {
    console.log("Selecting", walletName, name.value);
    name.value = walletName;
  };
  const onReadyStateChange = () => setWallet(wallet.value);
  const onConnect = () => setWallet(wallet.value);
  const onDisconnect = () => name.value = null;
  const invalidateListeners = watchEffect((onInvalidate) => {
    const _wallet = wallet.value;
    if (!_wallet)
      return;
    _wallet.on("readyStateChange", onReadyStateChange);
    _wallet.on("connect", onConnect);
    _wallet.on("disconnect", onDisconnect);
    _wallet.on("error", onError);
    onInvalidate(() => {
      _wallet.off("readyStateChange", onReadyStateChange);
      _wallet.off("connect", onConnect);
      _wallet.off("disconnect", onDisconnect);
      _wallet.off("error", onError);
    });
  });
  if (typeof window !== "undefined") {
    window.addEventListener("unload", invalidateListeners);
  }
  const connect = async () => {
    if (connected.value || connecting.value || disconnecting.value)
      return;
    if (!wallet.value)
      throw newError(new WalletNotSelectedError());
    if (!ready.value) {
      name.value = null;
      if (typeof window !== "undefined" && openOnboardingUrls.value) {
        window.open(wallet.value.url, "_blank");
      }
      throw newError(new WalletNotReadyError());
    }
    try {
      connecting.value = true;
      await wallet.value.connect();
    } catch (error) {
      name.value = null;
      throw error;
    } finally {
      connecting.value = false;
    }
  };
  const disconnect = async () => {
    if (disconnecting.value)
      return;
    if (!wallet.value) {
      name.value = null;
      return;
    }
    try {
      disconnecting.value = true;
      await wallet.value.disconnect();
    } finally {
      name.value = null;
      disconnecting.value = false;
    }
  };
  const sendTransaction = async (transaction, connection, options) => {
    if (!wallet.value)
      throw newError(new WalletNotSelectedError());
    if (!connected.value)
      throw newError(new WalletNotConnectedError());
    return await wallet.value.sendTransaction(transaction, connection, options);
  };
  const signTransaction = computed(() => {
    const _wallet = wallet.value;
    if (!(_wallet && "signTransaction" in _wallet))
      return;
    return async (transaction) => {
      if (!connected.value)
        throw newError(new WalletNotConnectedError());
      return await _wallet.signTransaction(transaction);
    };
  });
  const signAllTransactions = computed(() => {
    const _wallet = wallet.value;
    if (!(_wallet && "signAllTransactions" in _wallet))
      return;
    return async (transactions) => {
      if (!connected.value)
        throw newError(new WalletNotConnectedError());
      return await _wallet.signAllTransactions(transactions);
    };
  });
  const signMessage = computed(() => {
    const _wallet = wallet.value;
    if (!(_wallet && "signMessage" in _wallet))
      return;
    return async (message) => {
      if (!connected.value)
        throw newError(new WalletNotConnectedError());
      return await _wallet.signMessage(message);
    };
  });
  watchEffect(async () => {
    if (!autoConnect.value || !wallet.value || !ready.value || connected.value || connecting.value)
      return;
    try {
      connecting.value = true;
      await wallet.value.connect();
    } catch (error) {
      name.value = null;
    } finally {
      connecting.value = false;
    }
  });
  return {
    wallets,
    autoConnect,
    openOnboardingUrls,
    wallet,
    publicKey,
    readyState,
    ready,
    connected,
    connecting,
    disconnecting,
    select,
    connect,
    disconnect,
    sendTransaction,
    setWallet,
    signTransaction,
    signAllTransactions,
    signMessage
  };
};
let walletStore = null;
const useWallet = () => {
  if (walletStore)
    return walletStore;
  throw new WalletNotInitializedError("Wallet not initialized. Please use the `initWallet` method to initialize the wallet.");
};
const initWallet = (walletStoreProps) => {
  walletStore = createWalletStore(walletStoreProps);
};
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("button", {
    staticClass: "swv-button swv-button-trigger",
    attrs: {
      "disabled": _vm.disabled || _vm.disconnecting || !_vm.wallet
    },
    on: {
      "click": function(e) {
        return _vm.handleClick(e);
      }
    }
  }, [_vm.wallet ? _c("wallet-icon", {
    attrs: {
      "wallet": _vm.wallet
    }
  }) : _vm._e(), _c("p", {
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  })], 1)]);
};
var staticRenderFns$2 = [];
const __vue2_script$2 = {
  name: "WalletDisconnectButton",
  components: {
    WalletIcon
  },
  props: {
    disabled: Boolean
  },
  data() {
    return {
      wallet: null,
      disconnect: null,
      disconnecting: false
    };
  },
  computed: {
    content: () => {
      if (globalThis.disconnecting)
        return "Disconnecting ...";
      if (globalThis.wallet)
        return "Disconnect";
      return "Disconnect Wallet";
    }
  },
  methods: {
    handleClick: (event) => {
      globalThis.$emit("click", event);
      if (event.defaultPrevented)
        return;
      globalThis.disconnect().catch(() => {
      });
    }
  },
  mounted() {
    const { wallet, disconnect, disconnecting } = useWallet();
    this.wallet = wallet;
    this.disconnect = disconnect;
    this.disconnecting = disconnecting;
  }
};
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$2,
  render$2,
  staticRenderFns$2,
  false,
  __vue2_injectStyles$2,
  null,
  null,
  null
);
function __vue2_injectStyles$2(context) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var WalletDisconnectButton = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("div", {
    class: _vm.dark ? "swv-dark" : ""
  }, [_vm._t("default")], 2), _vm.open ? _c("portal", {
    attrs: {
      "to": _vm.container
    }
  }, [_c("div", {
    staticClass: "swv-modal",
    class: _vm.dark ? "swv-dark" : "",
    attrs: {
      "aria-labelledby": "swv-modal-title",
      "aria-modal": "true",
      "role": "dialog"
    }
  }, [_vm._t("overlay", function() {
    return [_c("div", {
      staticClass: "swv-modal-overlay",
      on: {
        "click": _vm.closeModal
      }
    })];
  }), _c("div", {
    ref: "modalPanel",
    staticClass: "swv-modal-container"
  }, [_vm._t("modal", function() {
    return [_c("div", {
      staticClass: "swv-modal-wrapper",
      class: {
        "swv-modal-wrapper-no-logo": !_vm.hasLogo
      }
    }, [_vm.hasLogo ? _c("div", {
      staticClass: "swv-modal-logo-wrapper"
    }, [_vm._t("logo", function() {
      return [_c("img", {
        staticClass: "swv-modal-logo",
        attrs: {
          "alt": "logo",
          "src": _vm.logo
        }
      })];
    })], 2) : _vm._e(), _c("h1", {
      staticClass: "swv-modal-title",
      attrs: {
        "id": "swv-modal-title"
      }
    }, [_vm._v(" Connect Wallet ")]), _c("button", {
      staticClass: "swv-modal-button-close",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.closeModal.apply(null, arguments);
        }
      }
    }, [_c("svg", {
      attrs: {
        "width": "14",
        "height": "14"
      }
    }, [_c("path", {
      attrs: {
        "d": "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
      }
    })])]), _c("ul", {
      staticClass: "swv-modal-list"
    }, _vm._l(_vm.walletsToDisplay, function(wallet) {
      return _c("li", {
        key: wallet.name,
        on: {
          "click": function() {
            return _vm.onSelect(wallet.name);
          }
        }
      }, [_c("button", {
        staticClass: "swv-button"
      }, [_c("p", {
        domProps: {
          "textContent": _vm._s(wallet.name)
        }
      }), _c("wallet-icon", {
        attrs: {
          "wallet": wallet
        }
      })], 1)]);
    }), 0), _vm.hiddenWallets.length > 0 ? _c("button", {
      staticClass: "swv-button swv-modal-collapse-button",
      class: {
        "swv-modal-collapse-button-active": _vm.expandedWallets
      },
      attrs: {
        "aria-controls": "swv-modal-collapse",
        "aria-expanded": _vm.expandedWallets
      },
      on: {
        "click": function() {
          return _vm.expandedWallets = !_vm.expandedWallets;
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.expandedWallets ? "Less" : "More") + " options "), _c("i", {
      staticClass: "swv-button-icon"
    }, [_c("svg", {
      attrs: {
        "width": "11",
        "height": "6",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c("path", {
      attrs: {
        "d": "m5.938 5.73 4.28-4.126a.915.915 0 0 0 0-1.322 1 1 0 0 0-1.371 0L5.253 3.736 1.659.272a1 1 0 0 0-1.371 0A.93.93 0 0 0 0 .932c0 .246.1.48.288.662l4.28 4.125a.99.99 0 0 0 1.37.01z"
      }
    })])])]) : _vm._e()])];
  })], 2)], 2)]) : _vm._e(), _c("portal-target", {
    attrs: {
      "name": _vm.container
    }
  })], 1);
};
var staticRenderFns$1 = [];
const __vue2_script$1 = {
  name: "WalletModalProvider",
  components: {
    WalletIcon
  },
  props: {
    open: { type: Boolean },
    featured: { type: Number, default: 3 },
    container: { type: String, default: "body" },
    logo: { type: String },
    dark: { type: Boolean }
  },
  data() {
    return {
      wallets: [],
      modalPanel: null,
      expandedWallets: false,
      selectWallet: null
    };
  },
  computed: {
    hasLogo: function() {
      return !!this.logo;
    },
    featuredWallets: function() {
      return this.wallets.slice(0, this.featured);
    },
    hiddenWallets: function() {
      return this.wallets.slice(this.featured);
    },
    walletsToDisplay: function() {
      return this.expandedWallets ? this.wallets : this.featuredWallets;
    }
  },
  methods: {
    closeModal: function() {
      this.$emit("close");
    },
    onSelect: function(walletName) {
      console.debug("Wallet selected", walletName);
      this.selectWallet(walletName);
      this.closeModal();
    }
  },
  mounted() {
    const { wallets, select } = useWallet();
    this.wallets = wallets;
    this.selectWallet = select;
  }
};
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1,
  render$1,
  staticRenderFns$1,
  false,
  __vue2_injectStyles$1,
  null,
  null,
  null
);
function __vue2_injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var WalletModalProvider = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("wallet-modal-provider", {
    attrs: {
      "featured": _vm.featured,
      "container": _vm.container,
      "logo": _vm.logo,
      "dark": _vm.dark,
      "open": _vm.dropdownOpened
    },
    on: {
      "close": function($event) {
        _vm.dropdownOpened = !_vm.dropdownOpened;
      }
    }
  }, [[_vm._t("default", function() {
    return [!_vm.wallet ? _c("button", {
      staticClass: "swv-button swv-button-trigger btn btn-primary text-white",
      on: {
        "click": function(e) {
          return _vm.openDropdown(e);
        }
      }
    }, [_vm._v(" Select Wallet ")]) : !_vm.publicKeyBase58 ? _c("div", [_c("wallet-connect-button", {
      attrs: {
        "connecting": _vm.connecting,
        "wallet": _vm.wallet
      },
      on: {
        "connect": _vm.doConnect
      }
    }), _c("span", {
      staticClass: "swv-change-wallet-text",
      on: {
        "click": function(e) {
          return _vm.openDropdown(e);
        }
      }
    }, [_vm._v("Change Wallet")])], 1) : _c("div", {
      staticClass: "swv-dropdown"
    }, [_vm._t("dropdown-button", function() {
      return [_c("button", {
        staticClass: "swv-button swv-button-trigger btn btn-primary text-white",
        style: {
          pointerEvents: _vm.dropdownOpened ? "none" : "auto"
        },
        attrs: {
          "aria-expanded": _vm.dropdownOpened,
          "title": _vm.publicKeyBase58
        },
        on: {
          "click": function(e) {
            return _vm.openDropdown(e);
          }
        }
      }, [_c("wallet-icon", {
        attrs: {
          "wallet": _vm.wallet
        }
      }), _c("p", {
        domProps: {
          "textContent": _vm._s(_vm.publicKeyTrimmed)
        }
      })], 1)];
    }), _vm._t("dropdown", function() {
      return [_c("ul", {
        ref: "dropdownPanel",
        staticClass: "swv-dropdown-list",
        class: {
          "swv-dropdown-list-active": _vm.dropdownOpened
        },
        attrs: {
          "aria-label": "dropdown-list",
          "role": "menu"
        }
      }, [_vm._t("dropdown-list", function() {
        return [_vm.canCopy ? _c("li", {
          staticClass: "swv-dropdown-list-item",
          attrs: {
            "role": "menuitem"
          },
          on: {
            "click": _vm.copyAddress
          }
        }, [_vm._v(" " + _vm._s(_vm.addressCopied ? "Copied" : "Copy address") + " ")]) : _vm._e(), _c("li", {
          staticClass: "swv-dropdown-list-item",
          attrs: {
            "role": "menuitem"
          },
          on: {
            "click": function(e) {
              _vm.openDropdown();
              _vm.closeDropdown();
            }
          }
        }, [_vm._v(" Change wallet ")]), _c("li", {
          staticClass: "swv-dropdown-list-item",
          attrs: {
            "role": "menuitem"
          },
          on: {
            "click": _vm.disconnect
          }
        }, [_vm._v(" Disconnect ")])];
      })], 2)];
    })], 2)];
  })], [_vm._t("modal-overlay")], [_vm._t("modal")]], 2);
};
var staticRenderFns = [];
const __vue2_script = {
  name: "WalletMultiButton",
  components: {
    WalletConnectButton,
    WalletIcon,
    WalletModalProvider
  },
  props: {
    featured: { type: Number, default: 3 },
    container: { type: String, default: "body" },
    logo: { type: String },
    dark: { type: Boolean },
    connecting: { type: Boolean },
    autoConnect: { type: Boolean, default: false },
    openOnboardingUrls: { type: Boolean, default: false },
    wallets: { type: Array, required: true }
  },
  data() {
    return {
      canCopy: false,
      addressCopied: false,
      publicKey: null,
      wallet: null,
      disconnect: null,
      connect: null,
      dropdownPanel: null,
      dropdownOpened: false
    };
  },
  computed: {
    publicKeyBase58: function() {
      var _a;
      return (_a = this.publicKey) == null ? void 0 : _a.toBase58();
    },
    publicKeyTrimmed: function() {
      if (!this.wallet || !this.publicKeyBase58)
        return null;
      return this.publicKeyBase58.slice(0, 4) + ".." + this.publicKeyBase58.slice(-4);
    }
  },
  methods: {
    doConnect: function(e) {
      if (!this.wallet)
        return;
      console.log("doConnect", this.wallet);
      this.connect();
    },
    copyAddress: () => {
    },
    openDropdown: function(e) {
      this.dropdownOpened = true;
    },
    closeDropdown: function(e) {
      this.dropdownOpened = false;
    }
  },
  beforeMount() {
    initWallet({
      wallets: this.wallets,
      autoConnect: this.autoConnect,
      openOnboardingUrls: this.openOnboardingUrls
    });
    const { publicKey, wallet, disconnect, connect, setWallet, readyState } = useWallet();
    this.publicKey = publicKey;
    this.wallet = wallet;
    this.disconnect = disconnect;
    this.connect = connect;
    if (this.wallet) {
      console.debug("selecting wallet:", this.wallet);
      setWallet(this.wallet);
    }
  }
};
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(
  __vue2_script,
  render,
  staticRenderFns,
  false,
  __vue2_injectStyles,
  null,
  null,
  null
);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var WalletMultiButton = /* @__PURE__ */ function() {
  return __component__.exports;
}();
function useAnchorWallet() {
  const walletStore2 = useWallet();
  return computed(() => {
    if (!walletStore2)
      return;
    const { signTransaction, signAllTransactions, publicKey } = walletStore2;
    if (!publicKey.value || !signTransaction.value || !signAllTransactions.value)
      return;
    return {
      publicKey: publicKey.value,
      signTransaction: signTransaction.value,
      signAllTransactions: signAllTransactions.value
    };
  });
}
export { WalletConnectButton, WalletDisconnectButton, WalletIcon, WalletModalProvider, WalletMultiButton, WalletNotInitializedError, WalletNotSelectedError, createWalletStore, initWallet, useAnchorWallet, useWallet };
//# sourceMappingURL=vue2-wallet-adapter.es.js.map
